import React, { Component } from "react";
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import {getFavoriteTopics,removeFavoriteTopics,addFavoriteTopics,sectionlist_all} from '../config/Variables';
import {baseurl} from '../config/Settings';
export default class FetchSections extends Component {
    constructor() {
        super();
        this.state = {
            hobbies: [],
            tid: '',
            messagelog: '',
            isLoading: true,
            loading: true,
            users: [],
            numberstid: [],
            error: null
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.Removetid = this.Removetid.bind(this);
      
      }
    

    handleInputChange(event) {
      const target = event.target;
      var value = target.value;
      if (target.checked) {
        this.state.hobbies.push(value);
      } else {
        const index = this.state.hobbies.indexOf(value);
  
        if (index > -1) {
          this.state.hobbies.splice(index, 1);
  
          this.state.hobbies.splice(index, 1)
          const x = this.state.hobbies.indexOf(value);
  
          if (this.state.hobbies.indexOf(value) > -1) {
            this.state.hobbies.splice(index, 1);
          } // 2nd parameter means remove one item only
        }
      }
    }


    async Removetid(event) {

        const target = event.target;
          var value = target.value;
      
          if (event.target.checked) {
            this.state.hobbies.push(value);
           // this.setState({messagelog:"اختر الكاتب المفضل لديك"});
          } else {
        const index = (this.state.hobbies).indexOf(parseInt(value, 2));
       
      
        for( var i = 0; i < this.state.hobbies.length; i++){ 
                if ( this.state.hobbies[i] == value) { 
                  this.state.hobbies.splice(i, 1); 
                }
             }
           // this.state.hobbies.splice(value, 1);
          }
        }

        
        
    async submit() {
        const tid = this.state.hobbies.join(',')
        const tidurl = this.state.hobbies.join('-')
        if (tid == "") {
            this.setState({ messagelog: "اختر المواضيع المفضلة لديك" });
        } else {

            if (localStorage.getItem('user-info')) {


                let item = { tid };
                let user = JSON.parse(localStorage.getItem('user-info'))
                let result = await fetch(addFavoriteTopics, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": 'application/json',
                        "Authorization": "Bearer " + user.token.access_token,
                    },
                    body: JSON.stringify(item)
                });
                result = await result.json();

                if (result.message.code == '200') {
                  window.dataLayer = window.dataLayer || [];

                  window.dataLayer.push({
                    event: 'personalize_section',
                    user_id: user.user.id,
                    personalize_sections: tid
                    });
                    this.props.samirCallback(tidurl);

                }

            }
        }
    }
    getFetchUsers() {
      var numberstid_constant=[];
      var numberstid_hobbies=[];
      let user = JSON.parse(localStorage.getItem('user-info'))
      let datt = fetch(getFavoriteTopics, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": 'application/json',
          "Authorization": "Bearer " + user.token.access_token,
        },
        body: JSON.stringify(this.state)
      }).then(response => response.json())
        .then(data => {
          if(data.webmsg.code==401){
            localStorage.clear();
            var domainurl=  window.location.origin;
            window.location.href = domainurl+'/journey';
          }
          data.data.map(({ tid }, index2) => {
            numberstid_constant.push(tid);
            numberstid_hobbies.push(tid);
          });
       
        this.setState({
            loading: true
        }, () => {
            fetch(sectionlist_all).then(res => res.json()).then(result => this.setState({
                loading: false,
                users: result.rows,
                numberstid: numberstid_constant,
                hobbies:numberstid_hobbies
            })).catch(console.log);
        });
      });
    }


    componentDidMount() {
        this.getFetchUsers();
    }

    render() {
        const {
            users,
            error,
            loading
        } = this.state;
        return (

          <div class="personal-wrap personal-wrap-tag"> 
                            <div class="personal-wrap-before"> 
                                <div class="progress-container">
                                    <div class="progress" id="progress"></div>
                                    <div class="progress-circle">1</div>
                                    <div class="progress-circle active">٢</div>
                                    <div class="progress-circle">٣</div>
                                </div>
                    
                                <div class="function-info">
                                <h3>حدد اهتماماتك ​</h3> 
                            <p>اختر مواضيعك المفضلة ​</p>
                                </div> 
                    
                                <div class="select-list">  
                                <div className="notif-message"><h3> {this.state.messagelog}</h3></div>
                                    <div class="select-list-inner" id="scroller"> 
                                        <div class="tags-list inner-scroll">   
                                         
                                        {loading ? <div className="loading-mypage" ><img src="https://aawsat.com/themes/custom/aawsatv3/assets-react/img/loading-new.gif?Sccs" /></div>: ""}


<React.Fragment>
{

users.map(({ name, tid }, index) => {
const fruitss = this.state.numberstid;

const ttt = parseInt(tid);

const ss = fruitss.includes(ttt); //true
if (ss) {
return (


<div className="tag-option" key={tid}>
<label htmlFor={`custom-checkbox-${tid}`} className="multi-check">
<input type="checkbox"   onClick={this.Removetid}  onChange={this.Removetid}    defaultChecked={true}  defaultValue={`${tid}`} id={`custom-checkbox-${tid}`} name="hobbies"  className="form-check" />
<div className="tag">{name}</div>
</label>
</div>

);

} else {
return (
<div className="tag-option" key={tid}>
<label htmlFor={`custom-checkbox-${tid}`} className="multi-check">
<input type="checkbox"   onChange={this.handleInputChange}    defaultValue={`${tid}`} id={`custom-checkbox-${tid}`} name="hobbies"  className="form-check"  />
<div className="tag">{name}</div>
</label>
</div>
);
}
})
}
</React.Fragment>
                                          
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="personal-wrap-after">
                                <div class="action-btn">
                                    <button type="submit" onClick={() => this.submit()}   className="button primary rounded next-btn">التالي</button>
                               
                                </div> 
                            </div>  
                        </div> 
);
    }
}
